import React from "react";
import Header from "./header";
import Footer from "./footer";
export default function Layout({ children }) {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main id="main" tabIndex="-1">
        {children}
      </main>
      <Footer />
    </>
  );
}
